import React from 'react';
import { motion } from 'framer-motion';
import { GraduationCapIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT_NAME } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <header className="border-b-4 border-brand-yellow bg-white" data-id="element-99" data-mp="4mi5dgdtryh4">
      <p className="flex items-center justify-center gap-1.5 bg-brand-blue px-3 py-1.5 text-xs font-semibold uppercase tracking-widest text-brand-yellow" data-id="element-100" data-mp="129h0vnss70df">
        <GraduationCapIcon size={13} aria-hidden="true" data-id="element-101" data-mp="xaxgvsxqzynp" />
        Método de enseñanza paso a paso
      </p>

      <div className="mx-auto max-w-2xl px-3 pb-5 pt-3 text-center sm:px-5" data-id="element-102" data-mp="s9ggrzn38g86">
        <motion.h1 initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE
      }} className="font-display text-[1.95rem] font-bold leading-[1.05] text-brand-blue sm:text-5xl" data-id="element-103" data-mp="nbexbdlr2ew6">
          El sistema completo para{' '}
          <span className="text-brand-red underline decoration-brand-yellow decoration-4 underline-offset-4" data-id="element-104" data-mp="3j925dog4jqvj">
            enseñar inglés en primaria
          </span>{' '}
          sin empezar cada clase desde cero
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.05
      }} className="mx-auto mt-2 max-w-xl text-sm leading-snug text-brand-muted sm:text-base" data-id="element-105" data-mp="39cpa4m4xl4yo">
          Organizá tus clases de inglés con contenidos, actividades,
          planificaciones y evaluaciones para niños de 6 a 12 años,{' '}
          <strong className="font-semibold text-brand-ink" data-id="element-106" data-mp="2viomanfip2d3">
            sin perder horas buscando materiales dispersos.
          </strong>
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.25,
        ease: EASE,
        delay: 0.1
      }} className="mt-2.5 inline-block rounded-lg bg-brand-yellow px-3 py-1.5 font-display text-sm font-bold uppercase leading-tight tracking-wide text-brand-ink" data-id="element-107" data-mp="2hjyot6osd0o7">
          {PRODUCT_NAME} · 6 Tomos + 5 Bonos
        </motion.p>

        <motion.a href={OFFER_ANCHOR} initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.14
      }} className="mt-2.5 block overflow-hidden rounded-2xl border-4 border-brand-blue bg-white" data-id="element-108" data-mp="i9vr34bbm0lu">
          <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-109" data-mp="112pzffefuuh3" />
        </motion.a>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: EASE,
        delay: 0.18
      }} className="mt-3" data-id="element-110" data-mp="x3h0zx8ge8f7">
          <CtaButton href={OFFER_ANCHOR} size="lg" data-id="element-111" data-mp="1x9b590wn91ck">
            🚀 Sí, quiero comenzar ahora
          </CtaButton>

          <p className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs font-semibold text-brand-muted" data-id="element-112" data-mp="21aeirgr7ylam">
            <span className="flex items-center gap-1" data-id="element-113" data-mp="2697najoj31yn">
              <ZapIcon size={12} className="text-brand-blue" data-id="element-114" data-mp="2b0fvxdi1ajar" />
              Acceso Digital Inmediato
            </span>
            <span className="text-brand-muted/50" data-id="element-115" data-mp="2g0lsn835uvzp">•</span>
            <span className="flex items-center gap-1" data-id="element-116" data-mp="2g258ixkwn50y">
              <ShieldCheckIcon size={12} className="text-brand-green" data-id="element-117" data-mp="2kxu8v34r0pyb" />
              Garantía de 7 Días
            </span>
          </p>
        </motion.div>
      </div>
    </header>;
}